export default {
  GAME_WIDTH: 960,
  GAME_HEIGHT: 960,
  GAME_CELL_SIZE: 96,

  GROUND_HEIGHT: 75,

  LIFE_RADIUS: 30,
  LIFE_CHANCE: 0.1,

  PLAYER_ONSCREEN_POSITION: 0.25,

  PLAYER_RADIUS: 28,
  PLAYER_LIVES_INITIAL: 3,
  PLAYER_LIVES_MAX: 5,
  PLAYER_ENERGY_MAX: 200,
  PLAYER_ENERGY_PER_SECOND: -10,
  PLAYER_SCORE_PER_SECOND: 0.25,

  PLAYER_ALTITUDE: 100,
  PLAYER_FLOAT_PERIOD: 2,
  PLAYER_FLOAT_AMPLITUDE: 10,
  PLAYER_ACCELERATION_X: 100,
  PLAYER_ACCELERATION_Y: 2500,
  PLAYER_MAX_VELOCITY_X: 600,
  PLAYER_MAX_VELOCITY_X_PER_SECOND: 5,
  PLAYER_MAX_VELOCITY_Y: 1000,
  PLAYER_JUMP_VELOCITY: -1000,
  PLAYER_MAX_JUMP_COUNT: 2,
  PLAYER_INVULNERABLE_DURATION: 3,

  TREASURE_SCORE: 10,
  TREASURE_ENERGY: 20,
  TREASURE_CHANCE: 0.1,
  TREASURE_WIDTH: 25,
  TREASURE_HEIGHT: 50,
  TREASURE_POSITION_LOW: 610,
  TREASURE_POSITION_HIGH: 400,
  TREASURE_FLOAT_PERIOD: 1,
  TREASURE_FLOAT_AMPLITUDE: 5,
  TREASURE_COLLECTED_FADE_OUT_DURATION: 0.75,
  TREASURE_COLLECTED_ROTATION_SPEED: 10,

  OBSTACLE_CHANCE: 0.1,
}
